import React from "react";
import { IconLoadingNotification } from "../../../../components/buttons/IconButtons";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Loading icon of the notifications, shown while a panel, an area or the expanded panel reads its next page.
 *
 * @param {string} className - Spacing around the icon.
 */
const PanelLoading = ({ className = 'py-2' }) => (
    <div className={`d-flex justify-content-center ${className}`}>
        <IconLoadingNotification className='icon-color-general-950 btn-icon-svg-32px loader' />
    </div>
);

export default PanelLoading;
